import React from 'react';
import range from 'lodash/range';
import { Step } from './Step';

/**
 * Status: *In progress*.
 * Category: Wizard
 */
var StepIndicator = function StepIndicator(props) {
  var _props$index = props.index,
      index = _props$index === void 0 ? 0 : _props$index,
      _props$numberOfSteps = props.numberOfSteps,
      numberOfSteps = _props$numberOfSteps === void 0 ? 0 : _props$numberOfSteps,
      labels = props.labels,
      links = props.links;
  return /*#__PURE__*/React.createElement("div", {
    className: "step-indicator"
  }, /*#__PURE__*/React.createElement("ol", {
    className: "step-indicator__list"
  }, range(numberOfSteps !== null && numberOfSteps !== void 0 ? numberOfSteps : 0).map(function (number) {
    var _labels$number, _links$number;

    return /*#__PURE__*/React.createElement(Step, {
      key: number,
      activeStep: index,
      index: number,
      numberOfSteps: numberOfSteps,
      label: (_labels$number = labels === null || labels === void 0 ? void 0 : labels[number]) !== null && _labels$number !== void 0 ? _labels$number : '',
      link: (_links$number = links === null || links === void 0 ? void 0 : links[number]) !== null && _links$number !== void 0 ? _links$number : ''
    });
  })));
};

export default StepIndicator;